import React from 'react';
import { defineMessages } from 'react-intl';
import Confirm from 'components/Confirm';
import Message from 'components/Message';
import appMessages from 'features/App/App.messages';

const messages = defineMessages({
  title: {
    id: 'yield-management.turn-on-smartspot-confirmation-modal.title',
    defaultMessage: 'Please confirm you wish to turn SmartSpot ON',
  },
  body: {
    id: 'yield-management.turn-on-smartspot-confirmation-modal.body',
    defaultMessage: 'Note: SmartSpot can take a couple of hours to initially adjust spots on your schedules.',
  },
});

const TurnOnSmartSpotConfirmationModal = props => (
  <Confirm
    title={<Message message={messages.title} />}
    cancelNode={<Message message={appMessages.cancel} />}
    acceptNode={<Message message={appMessages.yes} />}
    {...props}>
    <Message message={messages.body} />
  </Confirm>
);

export default TurnOnSmartSpotConfirmationModal;
